import styled from "@emotion/styled";
import * as React from "react";

import { Info } from "@livechat/design-system-icons";
import { DesignToken, Icon } from "@livechat/design-system-react-components";

import Text from "components/layout/Text";
import { withVar } from "themes/helpers";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  & > * {
    margin: 5px;
  }
`;

const StyledText = styled(Text)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TicketsToMergeNoData: React.FC = () => (
  <Wrapper>
    <Icon source={Info} size="xxlarge" />
    <StyledText fontWeight="600" fontSize="20px">
      No tickets to merge
    </StyledText>
    <StyledText width="400px" textAlign="center" color={withVar(DesignToken.ContentBasicSecondary)} lineHeight="22px">
      You need to have at least one ticket with open, pending, or on hold status from this requester to merge.
    </StyledText>
  </Wrapper>
);
